'use strict';

const summaryHelpers = require('../checkout/summary');

const SELECTORS = {
    element: '.js-giftcard',
    form: '.js-giftcard-form',
    formActive: '.js-giftcard-form-active',
    csrfToken: '.js-giftcard-form input[name="csrf_token"]',
    codeInput: '.js-giftcard-input',
    formWrap: '.cc-form__wrap',
    inputs: '.js-giftcard-form-active :input',
    error: '.js-giftcard-error',
    list: '.js-giftcard-list',
    template: '.js-giftcard-template',
    amountHintValue: '.js-giftcard-amount-hint-value',
    amountHint: '.js-giftcard-amount-hint',
    remainingAmountHint: '.js-giftcard-remaining-amount-hint',
    remainingAmountPaymentHint: '.js-giftcard-remaining-amount-payment-hint',
    remainingAmountPayment: '.js-giftcard-remaining-amount-payment',
    giftItem: {
        removeBtn: '.js-remove-giftcard',
        giftNum: '.js-giftcard-number',
        item: '.js-giftcard-item'
    },
    paymentOptions: '.js-payment-options',
    giftCertificateInput: '#rb_GIFTCARD',
    additionalFields: '.additionalFields',
    submitGiftcard: '.submit-giftcard',
    paymentInformation: '.payment-information',
    paymentMethod: '.paymentMethod',
    grandTotalSum: '.grand-total-sum',
    amountTotal: '.js-giftcard-amount-total'
};

const CLASSES = {
    inputError: 'cc-invalid',
    msgError: 'cc-message--visible',
    wrapError: 'cc-form__wrap--error',
}

/**
 * Giftcard class that handles the giftcard custom components on the checkout page
 */
class Giftcard {
    constructor(element) {
        this.element = element;
        this.form = element.find(SELECTORS.form);
        this.formActive = element.find(SELECTORS.formActive);
        this.inputs = element.find(SELECTORS.inputs);
        this.codeInput = element.find(SELECTORS.codeInput);
        this.error = element.find(SELECTORS.error);
        this.list = element.find(SELECTORS.list);
        this.csrfToken = element.find(SELECTORS.csrfToken);
        this.amountHint = element.find(SELECTORS.amountHint);
        this.amountHintValue = element.find(SELECTORS.amountHintValue);
        this.grandTotalSum = element.find(SELECTORS.grandTotalSum);
        this.remainingAmountPayment = element.find(SELECTORS.remainingAmountPayment);
        this.remainingAmountPaymentHint = element.find(SELECTORS.remainingAmountPaymentHint);
        this.remainingAmountHint = element.find(SELECTORS.remainingAmountHint);
        this.submitGiftcard = element.find(SELECTORS.submitGiftcard);

        this.init();
        this.initEvents();
    }

    /**
     * @description Initialize the giftcard component
     */
    init() {
        this.showGiftCard();
    }

    /**
     * @description Add event listeners on different elements
     */
    initEvents() {
        this.onFormSubmit();
        this.onRemoveButtonClick();
        this.onCloseCheckboxRemoveCode();
        this.onTotalChange();
    }

    showGiftCardHints() {
        const $form = $(this.form);
        const $giftCardAmountHint = $(this.amountHint);
        const $grandTotalSum = $(this.grandTotalSum).text();
        $form.find(SELECTORS.giftItem.giftNum).each(function() {
            const $giftNum = $(this).val();
            if ($giftNum && $giftNum.length > 0) {
                $($giftCardAmountHint).removeClass('d-none');
            }
            if ($grandTotalSum && $grandTotalSum.length > 0 && !$grandTotalSum.startsWith("0,00")) {
                $(this.remainingAmountPaymentHint).removeClass('d-none');
            }
        });
        if ($grandTotalSum && $grandTotalSum.length > 0 && $grandTotalSum.startsWith("0,00")) {
            $(this.remainingAmountHint).removeClass('d-none');
            $(this.formActive).addClass('d-none');
        }
    }

    showGiftCard() {
        this.showGiftCardHints();

        const $paymentOptions = $(SELECTORS.paymentOptions);
        const $amountTotal = $(SELECTORS.amountTotal);
        if ($paymentOptions.length > 0 && $paymentOptions.hasClass('d-none')) {
            $(SELECTORS.paymentInformation).data('payment-method-id', 'GIFT_CERTIFICATE');
        }
        if ($amountTotal && $amountTotal.data("giftcard-appplied")) {
            $(SELECTORS.giftCertificateInput).click();
            const $additionalFields = $(SELECTORS.giftCertificateInput).nextAll(SELECTORS.additionalFields);
            if ($additionalFields.hasClass('d-none')) {
                $additionalFields.removeClass('d-none');
            }
        }

        const countItems = $(SELECTORS.giftItem.item).filter(function() {
            return this.id;
        }).length;
        if (countItems >= 3) {
            $(this.formActive).addClass('d-none');
        }
    }

    /**
     * @description Event listener for the gift card form submit. After the submit an ajax call is performed in order to add the gift card to the order and a giftcard HTML node will be added on the page using a template as blueprint
     */
    onFormSubmit() {
        $(SELECTORS.formActive).on('submit', (evt) => {
            evt.preventDefault();

            $.spinner().start();

            var form = $(this.inputs).serialize();

            $.ajax({
                url: $(this.formActive).attr('action'),
                data: form,
                method: 'POST',
                dataType: 'json',
                success: (data) => {
                    $(this.formActive).find(this.codeInput).val('');

                    if (!data.givex || !data.givex.success || data.givex.applicable === false) {
                        this.showErrorMessage(data.givex.msg);
                    } else {
                        const cardData = {
                            number: data.givex.cardNumber,
                            balance: data.givex.applicableAmount,
                            expiration: data.givex.expirationDate,
                            giftCardAmountFormatted: data.cart.totals.giftCardAmountFormatted
                        }

                        const countItems = $(SELECTORS.giftItem.item).filter(function() {
                            return this.id;
                        }).length;
                        if (countItems >= 2) {
                            $(this.formActive).addClass('d-none');
                        }

                        this.addGiftcardItem(cardData);

                        const totals = data.cart.totals;
                        summaryHelpers.updateTotals(totals);
                        const isPartialPayment = data.givex.partial;

                        if (totals.totallyPaidWithGiftCard) {
                            $(this.amountHintValue).empty();
                            $(this.amountHintValue).text(totals.giftCardAmountFormatted);
                            $(this.amountHint).removeClass('d-none');
                            $(this.remainingAmountHint).removeClass('d-none');
                            $(this.remainingAmountPaymentHint).addClass('d-none');
                            $(SELECTORS.paymentOptions).addClass('d-none');
                            $(this.formActive).addClass('d-none');
                            $(SELECTORS.paymentInformation).data('payment-method-id', 'GIFT_CERTIFICATE'); 
                            $(this.formActive).closest('.paymentMethod').addClass('js-totally-paid-with-gift-card');

                            const paymentForm = $(SELECTORS.paymentMethod).closest('form');
                            const submitButton = paymentForm.find('button[type="submit"]');
                            submitButton.removeClass('cc-disabled').prop('disabled', false);

                            const activeRadioCheckboxes = paymentForm.find('.cc-form__radio:checked');
                            activeRadioCheckboxes.prop('checked', false).trigger('change');

                        } else {
                            $(this.amountHintValue).empty();
                            $(this.amountHintValue).text(totals.giftCardAmountFormatted);
                            $(this.amountHint).removeClass('d-none');
                            $(this.remainingAmountPayment).empty();
                            $(this.remainingAmountPayment).text(totals.grandTotal);
                            $(this.remainingAmountPaymentHint).removeClass('d-none');
                        }
                    }
                    $.spinner().stop();
                },
                error: (err) => {
                    $(this.formActive).find(this.codeInput).val('');
                    console.error(err);
                    this.showErrorMessage();
                    $(this.amountHint).addClass('d-none');
                    $(this.remainingAmountPaymentHint).addClass('d-none');
                    $.spinner().stop();
                }
            });
        });
    }

    /**
     *
     * @param {Object} data - the data necessary to populate the giftcard card item to show
     * @description Object structure = { number: data.givex.cardNumber, balance: data.givex.applicableAmount, expiration: data.givex.expirationDate }
     *
     */
    addGiftcardItem(data) {
        const $template = $(SELECTORS.template).clone();
        $template.attr('id', data.number);
        $template.find(SELECTORS.giftItem.removeBtn).attr('data-target', data.number);
        $template.find(SELECTORS.giftItem.giftNum).val(data.number);
        $(this.list).append($template);
        $template.removeClass(['js-giftcard-template', 'd-none']);
    }

    /**
     * @description This function will add a click event on the newly created remove btn on giftcard item, upon clicking the button the giftcard will be remove from the basket and the HTML node showing it will be cancelled from the DOM
     */
    onRemoveButtonClick() {
        $('body').on('click', SELECTORS.giftItem.removeBtn, (evt) => {
            evt.preventDefault();
            let $removeBtn = $(evt.currentTarget);
            this.clearErrorMessage();
            this.removeGiftCard($removeBtn);
        });
    }


     /**
     * @description Must be called when the Sum changes during checkout. Removes all giftcards previously entered to reset giftcard payment logic
     */
    onTotalChange() {
        $('body').on('giftcard:totalChange', (event, giftcardInput) => {
            for (let i = 0; i < $('.js-remove-giftcard').length-1 ; i++) {
                this.removeGiftCard($('.js-remove-giftcard')[i]);
            }
            if(giftcardInput) {
                this.showErrorMessage($(SELECTORS.error).data('changed-msg'));
            }
        });
    }

     /**
     * @param {Object} Object - The Button clicked to remove the gift card code during checkout
     * @description Removes a specific gift card code
     */

    removeGiftCard(button) {
        const $removeBtn = $(button);
        const action = $removeBtn.data('action');
        const $data = $removeBtn.data('target');
        var $target = "";
        if ($data) {
            $target = $(`#${$data}`);
        } else {
            return;
        }

        const token = $(this.csrfToken).val();
        const data = {
            cardNumber: $removeBtn.data('target'),
            token: token
        };

        $.ajax({
            url: action,
            data: data,
            method: 'POST',
            dataType: 'json',
            success: (data) => {
                if (data.success === false && data.message) alertMessage(data.message, 'cc-alert--danger');
                $target.remove();
                const totals = data.cart.totals;
                const paymentForm = $(SELECTORS.paymentMethod).closest('form');
                const submitButton = paymentForm.find('button[type="submit"]');
                if (totals.totalAmount > 0) $(SELECTORS.paymentOptions).removeClass('d-none');
                summaryHelpers.updateTotals(totals);
                $(this.amountHintValue).text(totals.giftCardAmountFormatted);
                $(this.remainingAmountPayment).text(totals.grandTotal);
                $(this.formActive).closest('.paymentMethod').removeClass('js-totally-paid-with-gift-card');

                if (totals.giftCardAmount == 0) {
                    $(this.amountHint).addClass('d-none');
                    $(this.remainingAmountHint).addClass('d-none');
                    $(this.remainingAmountPaymentHint).addClass('d-none');
                    submitButton.addClass('cc-disabled').prop('disabled', true);
                } else if (totals.totalAmount > 0) {
                    submitButton.addClass('cc-disabled').prop('disabled', true);
                    $(this.remainingAmountHint).addClass('d-none');
                    $(this.remainingAmountPaymentHint).removeClass('d-none');
                }
                $(this.formActive).removeClass('d-none');
            },
            error: (err) => {
                console.error(err);
                if (err.message) alertMessage(err.message, 'cc-alert--danger');
                $.spinner().stop();
            }
        });
    }

    /**
     * @param {string | undefined} specificErrorMsg - Possibile error message which is returned from the back-end side
     * @description Show a specific error message if present, otherwise it will show a generic error message under the gift card input
     */
    showErrorMessage(specificErrorMsg) {
        const errorMsg = specificErrorMsg || $(this.form).data('validity-error');

        $(this.error).removeClass('d-none');
        $(this.error).addClass(CLASSES.msgError).text(errorMsg);
        $(this.formActive).find(this.codeInput).addClass(CLASSES.inputError);
        $(this.formActive).find(this.codeInput).closest(SELECTORS.formWrap).addClass(CLASSES.wrapError);
    }

    /**
     * @description Hides and clears the gift card message during checkout
     */
    clearErrorMessage() {
        $(this.error).addClass('d-none').text("");
    }

    /**
     * 
     * @description Removes the codes when the checkbox is deselected
     */
    onCloseCheckboxRemoveCode() {
        const giftCardCheckbox = $(SELECTORS.paymentMethod).find('input[name="giftCard"]');

        giftCardCheckbox.change(function() {
            const giftRemoveBtn = $('.giftcard .js-remove-giftcard');

            if ($(this).not(":checked") && giftRemoveBtn.length) {
                giftRemoveBtn.each(function() {
                    $(this).trigger("click");
                });
            }
        });
    }
};

module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new Giftcard($(element));
    });
}